export const DYNAMIC_ACTIONS_PREFIX = '[Dynamic Actions]';

export const createDynamicEventName = (name: string) =>
  `${DYNAMIC_ACTIONS_PREFIX} ${name}`;

export function dispatchDynamicEvent(type: string, values?: unknown) {
  const event = new CustomEvent(createDynamicEventName(type), {
    detail: values ? values : undefined,
  });

  document.dispatchEvent(event);
}
